<!-- @format -->

<individual-confirm>
  <div class="container_heading">
    <h1 class="heading-01 heading_application">入力内容の確認</h1>
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
      </li>
      <li class="breadcrumb-item">
        <a onclick="{ back }">個人情報登録</a>
      </li>
      <li class="breadcrumb-item">入力内容の確認</li>
    </ul>
  </div>
  <!--/.container_heading-->

  <div class="lead_block">
    <p>
      以下の内容で個人情報登録を行います。
      <br />
      入力いただいた内容に誤りがないかご確認の上、「登録」ボタンをクリックしてください。
    </p>
  </div>
  <!--/.lead_block-->

  <div class="contents_block">
    <form class="application_form">
      <dl class="description_list">
        <template each="{ data in dataList(props.params) }">
          <dt class="description_list-term">{ data.label }：</dt>
          <dd
            class="description_list-definition { data.updated ? 'description_list-changes' :'' }"
          >
            <template if="{ data.label !== '事業内容' }">
              { data.text }
            </template>
            <template
              if="{ data.label === '事業内容' && typeof data.text === 'string' }"
            >
              <div each="{ text in data.text.split('\n') }">{ text }</div>
            </template>
          </dd>
        </template>
      </dl>
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          name="privacy"
          id="privacy"
          class="checkbox-input js-check"
          onclick="{ onCheck }"
        />
        <label for="privacy" class="checkbox-parts">
          <a target="_blank" href="https://cro-co.co.jp/privacypolicy/agreement/">
            CROCO株式会社の個人情報の取り扱い
          </a>
          に同意する
        </label>
      </div>

      <div class="container_button">
        <button
          class="button button-clear"
          type="button"
          value="戻る"
          data-target=""
          onclick="{ props.onBack }"
        >
          戻る
        </button>
        <button
          name="submit"
          class="button button-primary button_checked"
          type="button"
          value="上記内容で申請"
          data-target=""
          onclick="{ e => props.onSubmit(props.params) }"
          disabled
        >
          上記内容で登録
        </button>
      </div>
      <!--/.container_button-->
    </form>
    <!--/.application_form-->
  </div>
  <!--/.contents_block-->

  <!--/.application_form-->
  <script>
    import routes from "@model/menu-routes.js";

    export default {
      state: {
        privacy: false,
      },
      onBeforeMount() {
        this.routes = routes;
      },
      dataList(data) {
        const nc = (e) => (e ? e : "");
        const pref = this.props.prefs.find((e) => e.id == data.pref);
        const address = `${nc(data.zip)} ${pref ? pref.jname : ""} ${nc(
          data.address1
        )} ${nc(data.address2)}`;
        return [
          { label: "氏名", text: nc(data.name) },
          { label: "氏名(かな)", text: nc(data.kana) },
          {
            label: "住所",
            text: address == "   " ? "" : address,
          },
          { label: "電話番号", text: nc(data.tel) },
        ];
      },
      onCheck(e) {
        this.state.privacy = e.target.checked;
        this.$('button[name="submit"]').disabled = !this.state.privacy;
      },
    };
  </script>
</individual-confirm>
